// Pure builders for the composer "+ menu" text inserts (Location / Share a time).
// Both attach flows drop a readable line into the composer draft rather than inventing a
// send-path field — the scheduling assistant parses the place/time from the text, and the
// maps URL is made tappable by the chat's LinkifiedText (mirrors inbound WhatsApp locations).

export interface PlacePick {
  label: string;
  lat: number;
  lng: number;
}

// `📍 {label} — https://maps.google.com/?q={lat},{lng}` — the same shape inbound WhatsApp
// locations already render as, so no new bubble rendering is needed.
export function placeLine({ label, lat, lng }: PlacePick): string {
  return `📍 ${label} — https://maps.google.com/?q=${lat},${lng}`;
}

// A readable, locale-formatted datetime line, e.g. `🗓 Tue, Jul 29, 3:00 PM`.
export function shareTimeLine(date: Date, locale?: string): string {
  const formatted = new Intl.DateTimeFormat(locale, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
  return `🗓 ${formatted}`;
}

// Append a line to the current draft, separating with a newline when there's already text.
export function appendComposerLine(existing: string, line: string): string {
  const base = existing.replace(/\s+$/, '');
  return base ? `${base}\n${line}` : line;
}
